import {ProductInputProps, KColorProductSchema} from "./types";
import SearchSelect from "@ui-components/SearchSelect";
import {useEffect, useState} from "react";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";
import { FormattedMessage } from "react-intl";
import {Option} from "@feature/commons";
import _ from "lodash";
import {useIntl} from "react-intl";
import TranslatedKey from "../../../../components/TranslatedKey";
export const ProductInput = ({
  kColorProduct,
  setKColorProduct,
  color,
  selectableProducts,
  inSurvey = false,
  disabled = false,
  startResearchFrom = "product",
  productCompatibleColors,
}: ProductInputProps) => {

  const intl = useIntl();
  // only in survey we show buttons with images
  const useSelect = !inSurvey
  // state
  const [family, setFamily] = useState<Option>();
  const [products, setProducts]
    = useState<KColorProductSchema[]>();

  // hooks
  const apiRequest = useCountryAxiosInstance();

  // utils
  const familyOptions = _.uniq(products?.flatMap(p => p.des_family) || [])
    .map((fam:string) => ({ label: fam, value: fam }));
  const productOptions = products?.filter(p =>
    selectableProducts === '__all__' || selectableProducts.map(sp => sp.value).includes(p.cod_prod_comm))
    .filter(p => !family?.value || p.des_family.includes(family.value))
    .map(p => ({
      label: p.des_prod_comm,
      value: p.cod_prod_comm,
      kColorProduct: p,
    }));

  if (productOptions && productOptions.length === 1 && !kColorProduct) {
    // Auto-select if only one option is available
    setKColorProduct(productOptions[0].kColorProduct);
  }

  useEffect(() => {
    // When component mounts or color changes, fetch products (possibly filtered by color, if set)
    const config = {
      ...(startResearchFrom === 'color' ? {params: { color: color?.code }} : {}),
      publicRequest: true,
    };
    apiRequest!.get("/kcolors/products", config)
      .then((data: any) => setProducts(data))
  }, [color, selectableProducts]);

  useEffect(() => {
    setKColorProduct((prevProduct: KColorProductSchema) => {
      // If the currently selected product is unselectable, clear it
      /*
      Conditions for unselectability:
      - A)not present in selectableProducts (if selectedProducts is not '__all__', then all products are selectable...)
      - B)does not belong to the selected family (if any)
      - C)when starting from color: not compatible with the selected color (if any)
      if at least one of the conditions is true, return undefined to clear selection
       */
      if (prevProduct && (
        /*A*/(selectableProducts !== '__all__' && !selectableProducts.map(p=>p.value).includes(prevProduct.cod_prod_comm))||
        /*B*/(!!family?.value && !prevProduct.des_family.includes(family?.value)) ||
        /*C*/(!!productCompatibleColors && !!color && productCompatibleColors.length > 0
            && startResearchFrom === 'color' && !productCompatibleColors.includes(color.code))
      )) {
        return undefined;
      }
      return prevProduct;
    });
  }, [selectableProducts, family, color]);

  return <>
    {!inSurvey && <>
      <div className="flex mb-2">
        <p className="font-bold">
          <FormattedMessage id="product_family" defaultMessage="Famiglia prodotto" />
        </p>
        <p className="lowercase ml-1">
          (<FormattedMessage id="optional" defaultMessage="facoltativo" />)
        </p>
      </div>
      <div className="w-full md:w-1/2 lg:1/3 xl:w-1/4">
        {/* @ts-ignore */}
        <SearchSelect
          options={familyOptions}
          value={family}
          onChange={setFamily}
          isClearable={true}
          isDisabled={disabled}
        />
      </div>
    </>}
    <hr className="w-full border-gray-300 my-4"/>
    <p className="mb-2 font-bold">
      <FormattedMessage
        id="select_product"
        defaultMessage={"Seleziona un prodotto"}
      />
    </p>
    <div className={useSelect?"w-full md:w-1/2 lg:1/3 xl:w-1/4":"w-full"}>
      {startResearchFrom==='color' &&
      <span className={"text-xs text-italic text-gray-500"}>
        {intl.formatMessage({
          id: "start_from_color_warning",
          defaultMessage: "In base alla selezione vengono mostrate solo le combinazioni colore-prodotto effettivamente disponibili."
        })}
      </span>}
      {/* @ts-ignore */}
      {useSelect ?  <SearchSelect
        isClearable={true}
        options={productOptions}
        value={{
          label: kColorProduct?.des_prod_comm,
          value: kColorProduct?.cod_prod_comm,
          kColorProduct: kColorProduct,
        }}
        onChange={(e: {
          label: string;
          value: number;
          kColorProduct: KColorProductSchema;
        } | undefined) => {
          setKColorProduct(e?.kColorProduct);
        }}
        isDisabled={disabled}
      /> :
        // SELECT WITH BUTTONS AND IMAGES
        <div className={"w-full flex flex-wrap"}>
          {productOptions?.map((productOption) => (
            <div
              className={`mr-4 mb-4 cursor-pointer`}
              key={productOption.value}
            >
              <div className={`relative  flex flex-col w-40`}>
                <div
                  style={{
                    paddingBottom: "100%",
                    ...(productOption.kColorProduct.link_image
                      ? {backgroundImage: `url(${productOption.kColorProduct.link_image})`}
                      : {}),
                  }}
                  className={`absolute top-0 left-0 w-full h-full bg-cover bg-center bg-gray-100 relative border-2 ${
                    kColorProduct?.cod_prod_comm === productOption.value ? "border-am-700" : "border-transparent"}`}
                  onClick={() => setKColorProduct(productOption.kColorProduct)}
                >
                </div>
                <div className="mb-1 flex-col">
                  <p className="font-bold">
                    {/*<TranslatedKey id={productOption.kColorProduct.abstract}/>*/}
                    {productOption.kColorProduct.des_prod_comm}
                  </p>
                  <p className={"text-xs"}
                     dangerouslySetInnerHTML={{__html: productOption.kColorProduct.abstract || ""}}>
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      }
    </div>
  </>
};